var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "some-search-items", style: { marginLeft: _vm.ml + "px" } },
    [
      _vm._l(_vm.getList, function(item, idx) {
        return _c("li", { key: idx }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputVal,
                  expression: "inputVal"
                }
              ],
              attrs: { name: _vm.name, type: "checkbox" },
              domProps: {
                value: item["name" + _vm.$utils.U(_vm.$i18n.locale)],
                checked: Array.isArray(_vm.inputVal)
                  ? _vm._i(
                      _vm.inputVal,
                      item["name" + _vm.$utils.U(_vm.$i18n.locale)]
                    ) > -1
                  : _vm.inputVal
              },
              on: {
                change: function($event) {
                  var $$a = _vm.inputVal,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = item["name" + _vm.$utils.U(_vm.$i18n.locale)],
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.inputVal = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.inputVal = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.inputVal = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                style: { width: _vm.w + "px", textAlign: _vm.tl },
                attrs: { title: item["name" + _vm.$utils.U(_vm.$i18n.locale)] }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(item["name" + _vm.$utils.U(_vm.$i18n.locale)]) +
                    "\n        "
                ),
                _vm.showIcon
                  ? _c("i", {
                      class: !_vm.redType ? "el-icon-check" : "el-icon-close"
                    })
                  : _vm._e()
              ]
            )
          ])
        ])
      }),
      _vm._v(" "),
      !_vm.getList.length
        ? _c("li", { staticClass: "zdh-no-claims-tip" }, [_vm._v("No data")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74fedca6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fedca6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/letterSearch/SearchListBoss.vue
// module id = null
// module chunks = 